import ApiService from '@/utils/ApiService'
import getIdFromLink from '@/utils/getIdFromLink'

export default {
  namespaced: true,
  state: {
    isAgreementPreviewHTMLModalVisible: false,
    agreementId: '',
    base64data: null,
    isLoading: false,
    isFetchSuccessful: false
  },
  getters: {
    getIsAgreementPreviewHTMLModalVisible: (state) => state.isAgreementPreviewHTMLModalVisible,
    getAgreementId: (state) => state.agreementId,
    getBase64data: (state) => state.base64data,
    getIsLoading: (state) => state.isLoading,
    getIsFetchSuccessful: (state) => state.isFetchSuccessful
  },
  mutations: {
    reset (state) {
      state.isAgreementPreviewHTMLModalVisible = false
      state.agreementId = ''
      state.base64data = null
      state.isLoading = false
      state.isFetchSuccessful = false
    },
    toggleAgreementPreviewHTMLModal (state) {
      state.isAgreementPreviewHTMLModalVisible = !state.isAgreementPreviewHTMLModalVisible
    },
    setAgreementId (state, payload) {
      state.agreementId = payload
    },
    setBase64Data (state, payload) {
      state.base64data = payload
    },
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setIsFetchSuccessful (state) {
      state.isFetchSuccessful = !state.isFetchSuccessful
    }
  },
  actions: {
    async fetchAgreementAsPDF ({ commit, state }) {
      commit('toggleLoading')
      const response = await new ApiService(`e_x_a_b_agreements/${getIdFromLink(state.agreementId)}/get_pdf`).get()
      let data = await response.arrayBuffer()
      let myBlob = new Blob([data], { type: 'application/pdf' })
      let reader = new FileReader()
      reader.readAsDataURL(myBlob)
      reader.onloadend = () => {
        commit('setBase64Data', reader.result)
      }
      commit('setIsFetchSuccessful')
      commit('toggleLoading')
    },
    downloadPdf ({ commit, state }) {
      const linkSource = state.base64data
      const downloadLink = document.createElement('a')
      const fileName = 'agreementPreview.pdf'
      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    async fetchAgreementPreview ({ commit, state }, payload) {
      let agreement = JSON.parse(JSON.stringify(payload))
      delete agreement['@id']
      commit('toggleLoading')
      agreement.agreementTags = agreement.agreementTags.map(object => {
        return { tag: object.value }
      })
      agreement.agreementsConsents = agreement.agreementsConsents.map(consent => {
        return { consent: consent.consent['@id'], agree: consent.agree }
      })
      agreement.agreementCustomFields = agreement.agreementCustomFields.map(customField => {
        if (customField['@id']) {
          return { customField: customField['@id'], value: customField.value }
        }
        return { customField: customField.customField, value: customField.value }
      })
      agreement.agreementItems = agreement.agreementItems.map(entry => {
        return {
          '@id': entry['@id'],
          item: entry.item,
          dateFrom: entry.dateFrom,
          dateTo: entry.dateTo,
          alwaysSettleInFull: entry.alwaysSettleInFull,
          isCyclic: entry.isCyclic,
          agreement: agreement['@id'],
          promotion: entry.promotion
        }
      })
      agreement.agreementAdditionalItems = agreement.agreementAdditionalItems.map(entry => {
        return {
          '@id': entry['@id'],
          item: entry.item,
          dateFrom: entry.dateFrom,
          dateTo: entry.dateTo,
          alwaysSettleInFull: entry.alwaysSettleInFull,
          isCyclic: entry.isCyclic,
          agreement: agreement['@id'],
          promotion: entry.promotion,
          additionalDocumentTemplate: entry.additionalDocumentTemplate
        }
      })
      const response = await new ApiService(`e_x_a_b_agreements/get_pdf`).postSilent(agreement)
      let data = await response.arrayBuffer()
      let myBlob = new Blob([data], { type: 'application/pdf' })
      let reader = new FileReader()
      reader.readAsDataURL(myBlob)
      reader.onloadend = () => {
        commit('setBase64Data', reader.result)
      }
      commit('setIsFetchSuccessful')
      commit('toggleLoading')
    }
  }
}
